import { isPlatform } from "@ionic/react"

export const checkorigin = () => {
    if(isPlatform("mobileweb") || isPlatform("desktop") || isPlatform("pwa")) {
        //window?.location?.replace("http://missdiamondcameroon.com")
      }
}